
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { t } from "@/utils/translations";
import { Language } from "@/contexts/language";

interface UploadPhotoParams {
  file: File;
  userId: string;
  photoTitle: string;
  photoCategory: string;
  language: Language;
  onSuccess: () => void;
  onError: (error: any) => void;
  onFinally: () => void;
}

export async function uploadPhotoToGallery({
  file,
  userId,
  photoTitle,
  photoCategory,
  language,
  onSuccess,
  onError,
  onFinally
}: UploadPhotoParams) {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${Math.random().toString(36).substring(2, 15)}.${fileExt}`;
    const filePath = `${userId}/${fileName}`;

    const { error: uploadError, data } = await supabase.storage
      .from('gallery')
      .upload(filePath, file);

    if (uploadError) throw uploadError;

    const { data: { publicUrl } } = supabase.storage
      .from('gallery')
      .getPublicUrl(filePath);

    const { error: insertError } = await supabase
      .from('gallery_photos')
      .insert({
        title: photoTitle || 'Untitled Photo',
        url: publicUrl,
        user_id: userId,
        category: photoCategory
      } as any);

    if (insertError) throw insertError;

    toast.success(t('gallery.photoUploadedSuccess', language));
    onSuccess();
  } catch (error) {
    console.error("Error uploading photo:", error);
    toast.error(t('gallery.photoUploadFailed', language));
    onError(error);
  } finally {
    onFinally();
  }
}
